import { useSelector } from 'react-redux';
import { selectIsMuted } from '../redux/settings/selectors';
import chatSound from '../assets/sounds/chat_here_i_am.mp3';
import replyMessageSound from '../assets/sounds/chat_reply_notification.mp3';

export const useSounds = () => {
  const isMuted = useSelector(selectIsMuted);
  const playChatNotification = () => {
    if (isMuted) {
      return;
    }
    const audio = new Audio(chatSound);
    audio.play();
  };

  const playReplyChatNotification = () => {
    if (isMuted) {
      return;
    }
    const audio = new Audio(replyMessageSound);
    audio.play();
  };
  return { playChatNotification, playReplyChatNotification };
};
